'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class Footer extends Component {
  render() {
    const footerClassNames = this.props.isFixed ? "fixed" : "";
    return /*#__PURE__*/_jsx("footer", {
      className: footerClassNames,
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex flex-direction-column align-items-center wsg-container",
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("a", {
            href: "https://legal.hubspot.com/privacy-policy",
            className: "footer-link",
            style: {
              marginRight: 8
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "footer.privacyPolicy"
            })
          }), "|", /*#__PURE__*/_jsx("a", {
            href: "https://legal.hubspot.com/legal-stuff",
            className: "footer-link",
            style: {
              marginLeft: 8
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "footer.legalStuff"
            })
          })]
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "footer.poweredBy",
          style: {
            marginTop: 8
          }
        })]
      })
    });
  }
}
Footer.propTypes = {
  isFixed: PropTypes.bool
};